import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconSingleBed = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconSingleBed",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M160-481q0-33 24-56t56-23v-120q0-33 24-56t56-24h320q33 0 57 24t23 56v120q33 0 57 24t23 56v146q0 23-15 39t-39 15l-22 67q-2 6-7 10t-11 3h-12q-6 0-11-3t-7-10l-22-67H306l-22 67q-2 6-7 10t-11 3h-12q-6 0-11-3t-7-10l-22-67q-23 0-38-15t-16-39zm360-79h120v-120H520zm-200 0h120v-120H320z"
  })
}));